<ng-container *transloco="let t">
  <form [formGroup]="form" [enterAction]="addObservation.bind(this)">
    <div formArrayName="observations" class="content-wrapper padding-top-xs">
      @for (
        observation of observations.controls;
        track observation;
        let i = $index
      ) {
        <div [formGroupName]="i" class="gap-s flex-start">
          <mat-form-field appearance="outline">
            <mat-label>{{ t('Date') }}</mat-label>
            <input appAutofocus
              matInput
              [matDatepicker]="datePickerRefs[i]"
              formControlName="date"
            
          [min]="minDate" [max]="today"
        />
            <mat-datepicker-toggle
              matSuffix
              [for]="datePickerRefs[i]"
            ></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ t('Finding') }}</mat-label>
            <input matInput formControlName="finding" />
          </mat-form-field>

          @if (observations.length > 1) {
            <button style="margin-top: 4px"
              mat-icon-button
              (click)="removeObservation(i)" aria-label="Icon button">
              <mat-icon class="remove-icon"></mat-icon>
            </button>
          }
        </div>
      }
    </div>
    <div
      style="height: 44px; width: 200px"
      class="margin-bottom-s"
      [matTooltip]="
        observations.controls[observations.length - 1].valid
          ? null
          : t('Select a date and write a note so you can add a new row')
      "
      matTooltipShowDelay="200"
      matTooltipPosition="above"
    >
      <button
        [disabled]="!observations.controls[observations.length - 1].valid"
        mat-flat-button
        class="primary-btn"
        (click)="addObservation()"
      >
        <mat-icon class="plus-icon"></mat-icon> {{ t('Add new row') }}
      </button>
    </div>

    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>{{ t('Note') }}</mat-label>
      <textarea matInput rows="4" formControlName="note"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </form>
</ng-container>
